import {
    apiRequest,
    tugasTambahanCreate,
    tugasTambahanCheck,
    tugasTambahanUpdate,
    tugasTambahanDetail,
    tugasTambahanList,
    tugasTambahanInactive,
    tugasTambahanDetailInactive,
    tugasTambahanListPegawai,
    tugasTambahanListJabatan,
    tugasTambahanListUnitKerja,
} from "../../../../../services/adapters/kepegawaian/TugasTambahanService"

class IndexRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", tugasTambahanList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", tugasTambahanCreate, {
            body: query,
        }, true)
    }
    fetchCheck = async (query) => {
        return await apiRequest("post", tugasTambahanCheck, {
            body: query,
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", tugasTambahanUpdate, {
            body: query,
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", tugasTambahanDetail, {
            params: query,
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", tugasTambahanInactive, {
            body: query,
        }, true)
    }

    fetchDetailInactive = async (query) => {
        return await apiRequest("post", tugasTambahanDetailInactive, {
            body: query
        }, true)
    }
    
    fetchListPegawai = async (query) => {
        return await apiRequest("get", tugasTambahanListPegawai, {
            params: query,
        }, true)
    }

    fetchListJabatan = async (query) => {
        return await apiRequest("get", tugasTambahanListJabatan, {
            params: query,
        }, true)
    }

    fetchListUnitKerja = async (query) => {
        return await apiRequest("get", tugasTambahanListUnitKerja, {
            params: query,
        }, true)
    }

}

export default IndexRepository;